import { createSlice, PayloadAction } from "@reduxjs/toolkit"

const INITIAL_STATE = { isLoading: false, error: null as string | null }

export const BulkSendSlice = createSlice({
  name: "bulkSend",
  initialState: INITIAL_STATE,
  reducers: {
    bulkSendSuccess: (state) => { state.isLoading = false; state.error = null },
    bulkSendFailure: (state, action: PayloadAction<any>) => { state.isLoading = false; state.error = action.payload?.statusText ?? "failed" },
  },
})

export const { bulkSendSuccess, bulkSendFailure } = BulkSendSlice.actions
export const BulkSendReducer = BulkSendSlice.reducer
